import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BeTarefaEtiqueta } from '@app/models/be-tarefa';
import { ColorFormat } from '@app/components/color-picker/interfaces';

export interface DialogTarefaEtiquetaData {
  etiqueta?: BeTarefaEtiqueta;
}

@Component({
  selector: 'app-dialog-tarefa-etiqueta',
  templateUrl: './dialog-tarefa-etiqueta.component.html',
  styleUrls: ['./dialog-tarefa-etiqueta.component.css']
})
export class DialogTarefaEtiquetaComponent {
  public noEtiqueta = '';
  public noCor = '#1976D2';
  public formatoCor: ColorFormat = 'hex';

  public constructor(
    @Inject(MAT_DIALOG_DATA) public readonly data: DialogTarefaEtiquetaData,
    private readonly dialogRef: MatDialogRef<DialogTarefaEtiquetaComponent>
  ) {
    if (data.etiqueta) {
      this.noEtiqueta = data.etiqueta.noEtiqueta;
      this.noCor = data.etiqueta.noCor;
    }
  }

  public salvar(): void {
    const noEtiqueta = this.noEtiqueta.trim();
    if (!noEtiqueta) return;
    this.dialogRef.close({ ...this.data.etiqueta, noEtiqueta, noCor: this.noCor });
  }

  public cancelar(): void {
    this.dialogRef.close();
  }
}
